export default __webpack_public_path__ + "assets/images/Arrow Down-cc503ce3aed60e04f48aa287b864ae9f.svg";